export default {
  msThText: 'ms-th-text',
  msThDate: 'ms-th-date',
  msThBoolean: 'ms-th-boolean',
  msThEnum: 'ms-th-enum',
  msThNumber: 'ms-th-number',
  msThState:'ms-th-state'
};
